export function timerFormatter(seconds) {
	const days = Math.floor(seconds / 86400);
	const hours = Math.floor((seconds % 86400) / 3600);
	const minutes = Math.floor((seconds % 3600) / 60);
	const secs = seconds % 60;

	if (days > 0) {
		// Format for more than 24 hours: d:hh:mm
		const timeParts = [hours, minutes].map((part) =>
			part.toString().padStart(2, '0')
		);
		return `${days}d:${timeParts[0]}:${timeParts[1]}`;
	} else {
		// Format for less than 24 hours: hh:mm:ss
		const timeParts = [hours, minutes, secs].map((part) =>
			part.toString().padStart(2, '0')
		);
		return timeParts.join(':');
	}
}
